import { useState, useRef, useEffect } from "react";

export function useFeedback(duration = 4000) {
  const [feedback, setFeedback] = useState(null);
  const timerRef = useRef(null);

  useEffect(() => () => clearTimeout(timerRef.current), []);

  const showFeedback = (type, msg) => {
    clearTimeout(timerRef.current);
    setFeedback({ type, msg });
    timerRef.current = setTimeout(() => setFeedback(null), duration);
  };

  return [feedback, showFeedback];
}
